import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DismissButton from "../../Buttons/DismissButton";
import SuccessButton from "../../Buttons/SuccessButton";

class AddTextModal extends Component{

  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
  }

  onSave = () => {
    if(this.props.onSave){
      this.props.onSave(this.textAreaRef.current.value)
    }
  };

  render() {
    const { onDismiss, text, readOnly} = this.props;
    const btnStyle = {
      fontSize: '14px',
      height: '30px',
      width: '90px'
    };

    return (
      <div className="speech-bubble-ds">
        <textarea
          ref={this.textAreaRef}
          autoFocus
          className="addTextModal__text-area"
          dataLimitRows
          readOnly={readOnly}
          rows={3}
        >{text}</textarea>
        <div className="addTextModal__buttons">
          <DismissButton onClick={onDismiss} style={btnStyle}>
            CANCEL
          </DismissButton>
          <SuccessButton onClick={this.onSave} style={btnStyle}>
            SAVE
          </SuccessButton>
        </div>
        <div className="speech-bubble-ds-arrow" />
      </div>
    );
  }
}

AddTextModal.propTypes = {
  /** Dismiss button function */
  onDismiss: PropTypes.func,
  /** Save button function */
  onSave: PropTypes.func
};

export default AddTextModal;
